<template>
    <div>
      <shoppingCart />
    </div>
</template>

<script>
export default {
  components: {
    shoppingCart: () => import('@/components/Gracz/Sales/Cart/ShoppingCart')
  },
  created () {
    this.$EventBus.$emit('getPath')
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  watch: {
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
